import {AsiaDifficultyLevel} from "./types";

import {GAME_ASIA} from "../../../Games";
import {Game} from "../../../types";
import {StringUtil} from "../../../../shared/string_util";
import {$KTS} from "../../../../shared/types";
import {MapGameFragment} from "../MapGameFragment";
import {ReactComponent as AsiaMap} from "../res/asia.svg";
import {Component} from "react";
import {Country, ASIA_COUNTRIES} from "../types";

export class AsiaGameFragment extends MapGameFragment<AsiaDifficultyLevel> {

  protected getGame(): Game {
    return GAME_ASIA;
  }

  protected allCountries(): Country[] {
    return ASIA_COUNTRIES;
  }

  protected getMapComponent(): typeof Component {
    //@ts-ignore
    return AsiaMap;
  }

  protected getLevels(): AsiaDifficultyLevel[] {
    return AsiaDifficultyLevel.VALUES;
  }

  protected getResultText(): string {
    let resultText: string = "You completed %{level} game.";
    switch (this.state.gameConfig.level) {
      case AsiaDifficultyLevel.MEDIUM:
        resultText = StringUtil.format(resultText, $KTS("level", "a medium"));
        break;
    }
    return resultText;
  }
}